import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Footer: React.FC = () => {
  return (
    // <div className="container py-4">
      // <div className="p-4 border rounded-4 shadow-sm bg-white">
        <footer className="position-relative text-white ">
         {/* Main Footer Section */}
          <div
            className="px-4 py-5 rounded-4"
            style={{
              backgroundImage: "url('/Images/footer-bg.jpg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="container">
              <div className="row text-start align-items-start">
                {/* Left CTA */}
                <div className="col-md-4 mb-4">
                  <h2 className="fw-bold" style={{ fontSize: '2.5rem', lineHeight: '1.2' }}>
                    Making Luxury<br />Living Effortless
                  </h2>
                </div>

                {/* Quick Links */}
                <div className="col-md-4 mb-4">
                  <h5 className="fw-bold mb-3">Quick links</h5>
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      <Link to="/about-us" className="text-white text-decoration-none">About us</Link>
                    </li>
                    <li className="mb-2">
                      <Link to="/contact-us" className="text-white text-decoration-none">Contact us</Link>
                    </li>
                    <li className="mb-2">
                      <a href="#studies" className="text-white text-decoration-none">Studies</a>
                    </li>
                    <li className="mb-2">
                      <a href="#testimonials" className="text-white text-decoration-none">Testimonials</a>
                    </li>
                  </ul>
                </div>

                {/* Contact Info */}
                <div className="col-md-4 mb-4">
                  <h5 className="fw-bold mb-3">Contact us</h5>
                  <ul className="list-unstyled">
                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-telephone-fill me-2"></i>
                      <a href="tel:+919152122888" className="text-white text-decoration-none">
                        +91 91521 22888
                      </a>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-envelope-fill me-2"></i>
                      <a href="mailto:iosinfo@iosrelocations.com" className="text-white text-decoration-none">
                        iosinfo@iosrelocations.com
                      </a>
                    </li>
                    <li className="d-flex align-items-start">
                      <i className="bi bi-geo-alt-fill me-2 mt-1"></i>
                      <span>
                        706, 7th Floor Arun chambers, 80,<br />
                        Tardeo Rd, Tardeo, Mumbai,<br />
                        Maharashtra 400034. INDIA.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <hr className="text-white" />

              {/* Bottom Bar */}
              <div className="d-flex justify-content-between align-items-center pt-3 flex-wrap">
                <small className="mb-2 mb-md-0">
                  © 2025 iOS Relocation. All rights reserved.
                </small>
                <div className="d-flex gap-3">
                  <a href="https://www.facebook.com" aria-label="iOS Relocation on Facebook" className="text-white" style={{ fontSize: '1.2rem' }} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-facebook" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.instagram.com" aria-label="iOS Relocation on Instagram" className="text-white" style={{ fontSize: '1.2rem' }} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-instagram" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.linkedin.com" aria-label="iOS Relocation on LinkedIn" className="text-white" style={{ fontSize: '1.2rem' }} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-linkedin" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.twitter.com" aria-label="iOS Relocation on Twitter" className="text-white" style={{ fontSize: '1.2rem' }} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-twitter" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      // </div>
    // </div>
  );
};

export default Footer;
